import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ISalaryFileDataTableRowFormMeta {
  idBatch: FormInputMeta,
  intgDate: FormInputMeta,
  added: FormInputMeta,
  salary: FormInputMeta,
  returned: FormInputMeta,
  canceled: FormInputMeta,
  procDate: FormInputMeta,
  idBank: FormInputMeta,
  status: FormInputMeta,
  
  schema: any,
}

const SalaryFileDataTableRowFormMeta = {} as ISalaryFileDataTableRowFormMeta;


SalaryFileDataTableRowFormMeta.idBatch = {
  name: 'idBatch',
  type: 'text',
  label: 'Batch ID',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.intgDate = {
  name: 'intgDate',
  type: 'date',
  label: 'Date Intg',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.added = {
  name: 'added',
  type: 'text',
  label: 'Ajout',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.salary = {
  name: 'salary',
  type: 'text',
  label: 'Salaire',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.returned = {
  name: 'returned',
  type: 'text',
  label: 'Restitué',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.canceled = {
  name: 'canceled',
  type: 'text',
  label: 'Annulé',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.procDate = {
  name: 'procDate',
  type: 'date',
  label: 'Date Proc.',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID Banque',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(SalaryFileDataTableRowFormMeta));

export default SalaryFileDataTableRowFormMeta;